function to_array(collection) {
  return Array.prototype.slice.call(collection);
}

module.exports = to_array;
